import { render, staticRenderFns } from "./UserDocumentForm.vue?vue&type=template&id=23d781fd&"
import script from "./UserDocumentForm.vue?vue&type=script&lang=js&"
export * from "./UserDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports